var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookRoundedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9940_1089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 20.1014C15.3023 20.1014 19.6004 15.8033 19.6004 10.5014C19.6004 5.19943 15.3023 0.901367 10.0004 0.901367C4.69846 0.901367 0.400391 5.19943 0.400391 10.5014C0.400391 15.8033 4.69846 20.1014 10.0004 20.1014Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7374 13.277L14.1626 10.5014H11.5004V8.70045C11.5004 7.94174 11.8716 7.20058 13.0651 7.20058H14.276V4.83804C14.276 4.83804 13.1771 4.65039 12.1268 4.65039C9.93436 4.65039 8.50064 5.97881 8.50064 8.3859V10.5014H6.0625V13.277H8.50064V19.9853C8.98935 20.0622 9.4902 20.1014 10.0005 20.1014C10.5108 20.1014 11.0117 20.0609 11.5004 19.9853V13.277H13.7374Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9940_1089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(0.400391 0.900391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookRoundedIcon);
export default __webpack_public_path__ + "static/media/facebook-rounded-icon.cf8cef88.svg";
export { ForwardRef as ReactComponent };